import { FC } from "react";
import { useLocales } from "../../hooks";
import {
  clean,
  locale,
  params,
  priorityOptions,
  workOrderStatusOptions,
  workOrderTypeOptions,
} from "../../utils";
import { Form, Formik } from "formik";
import { workOrderFilterInitials } from "../../interfaces/WorkOrder";
import { Grid } from "@mui/material";
import {
  ApplyFilterButton,
  AutocompleteArrayInput,
  ClearButton,
  TextInput,
} from "../../components";
import { useParams } from "react-router-dom";

interface IListFilter {
  onSubmit: Function;
}

const WorkOrderListFilter: FC<IListFilter> = ({ onSubmit }) => {
  const { translate } = useLocales();
  const { customerId } = useParams();

  function submitHandler(values: any) {
    const cleanedValues = clean({
      ...values,
    });
    const { typeId, statusId, priorityId, customerIds } = values;
    if (typeId.length > 0) cleanedValues.typeIds = typeId;
    if (statusId.length > 0) cleanedValues.statusIds = statusId;
    if (priorityId.length > 0) cleanedValues.priorityIds = priorityId;
    if (customerIds.length > 0) cleanedValues.customerIds = values.customerIds;
    onSubmit({
      resource: `fixity/workorder/workorder`,
      params: {
        ...params,
        filter: { ...cleanedValues, customerIds: customerId },
      },
    });
  }

  return (
    <div style={{ marginBottom: "30px" }}>
      <Formik initialValues={workOrderFilterInitials} onSubmit={submitHandler}>
        {(props) => (
          <Form>
            <Grid
              container
              spacing={3}
              justifyContent="flex-end"
              sx={{ marginTop: 2 }}
            >
              <Grid item md={4}>
                <TextInput
                  name="workOrderNumber"
                  label={translate("resources.workOrders.work_order_number")}
                />
              </Grid>
              <Grid item md={4}>
                <TextInput
                  name="title"
                  label={translate("resources.workOrders.title")}
                />
              </Grid>
              <Grid item md={4}>
                <TextInput
                  name="description"
                  label={translate("resources.workOrders.description")}
                />
              </Grid>
              {/* <Grid item md={3}>
              <ReferenceDropDown
                name="organizationGroupId"
                label={translate("resources.recommandation.organization")}
                reference="setting/ldap/get-ldap-groups"
                query={{ isDeleted: "false" }}
                optionName="name"
              />
            </Grid> */}
              <Grid item md={4}>
                <AutocompleteArrayInput
                  name="priorityId"
                  label={translate("resources.workOrders.priority")}
                  options={locale(priorityOptions, "resources.workOrders.")}
                />
              </Grid>
              <Grid item md={4}>
                <AutocompleteArrayInput
                  name="typeId"
                  label={translate("resources.workOrders.typeId")}
                  options={locale(
                    workOrderTypeOptions,
                    "resources.workOrders."
                  )}
                />
              </Grid>
              <Grid item md={4}>
                <AutocompleteArrayInput
                  name="statusId"
                  label={translate("resources.workOrders.statusId")}
                  options={locale(
                    workOrderStatusOptions,
                    "resources.workOrders."
                  )}
                />
              </Grid>
              <Grid item>
                <ClearButton
                  onSubmit={onSubmit}
                  defaultFilter={{
                    customerIds: customerId,
                  }}
                />
              </Grid>
              <Grid item>
                <ApplyFilterButton />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default WorkOrderListFilter;
